import { ActionBox } from "./ActionBox";
import { DisplayReward } from "components/DIP/types/display-item";
import { pwaAssets } from "assets/cdn";
import { Column, Container, Icon, SubTitle, Title } from "./styles";
import { useImagePath } from "hooks/useImagePath";

export interface Props {
	rewards?: DisplayReward[];
	onClick: () => void;
}

const MegaMenuView = ({ rewards, onClick }: Props) => {
	const { getImage } = useImagePath("cdn");
	const bannerIcon = getImage(pwaAssets.bannerIcon);
	const info = {
		title: "Add to home screen!",
		subtitle: "Quick access to the Web Shop"
	};

	return (
		<Container>
			<Icon src={bannerIcon} />
			<Column>
				<Title>{info.title}</Title>
				<SubTitle>{info.subtitle}</SubTitle>
			</Column>
			<Column
				style={{
					justifyContent: "flex-end",
					height: "100%"
				}}
			>
				<ActionBox rewards={rewards} onClick={onClick} />
			</Column>
		</Container>
	);
};

export default MegaMenuView;
